export default __webpack_public_path__ + "static/media/floorplans.ce7acf05.pdf";